/** "Feb 1998" style month/year, or '' when the value is missing or invalid. */
export function formatMonthYear(value) {
    if (!value) return '';
    const d = new Date(value);
    if (Number.isNaN(d.getTime())) return '';
    return d.toLocaleDateString(undefined, { month: 'short', year: 'numeric' });
}

export function formatRange(start, end) {
    const from = formatMonthYear(start);
    const to = end ? formatMonthYear(end) : 'Present';
    if (!from && !end) return '';
    return `${from || '—'} – ${to || 'Present'}`;
}
